import { useEffect, useRef, useState } from 'react'
import { api, ErroApi } from '../lib/api'
import { Marca } from '../componentes/Marca'
import './conta-fluxo.css'

/**
 * Confirmar o e-mail, com o token do link.
 *
 * ─── A GUARDA DE REF NÃO É PARANOIA ───────────────────────────────
 *
 * O token é de **uso único**: o banco o queima na primeira chamada. O
 * StrictMode do React 19 roda todo `useEffect` DUAS vezes em
 * desenvolvimento. Sem a trava, a segunda chamada chegaria com o token
 * já consumido, receberia `TOKEN_INVALIDO`, e a tela anunciaria erro
 * num caso que deu certo — o pior tipo de bug, porque some em produção
 * e sobrevive em toda revisão feita no ambiente de desenvolvimento.
 *
 * ─── POR QUE ISTO IMPORTA MAIS DO QUE PARECE ──────────────────────
 *
 * A coluna `usuario.email_verificado_em` é ESCRITA em três lugares e
 * lida em nenhum: `app.buscar_para_login` nem a devolve. Enquanto esta
 * tela não existir, exigir verificação no login trancaria todo mundo do
 * lado de fora. Esta tela vem PRIMEIRO; o aperto no login vem depois.
 */
export function Confirmar({ token, aoEntrar }: { token: string; aoEntrar(): void }) {
  const [fase, setFase] = useState<'confirmando' | 'ok' | 'falhou'>('confirmando')
  const [motivo, setMotivo] = useState<string | null>(null)
  const jaFoi = useRef(false)

  useEffect(() => {
    if (jaFoi.current) return
    jaFoi.current = true
    void (async () => {
      try {
        await api('/v1/conta/verificar', { metodo: 'POST', corpo: { token } })
        setFase('ok')
      } catch (err) {
        setMotivo(err instanceof ErroApi && err.codigo === 'TOKEN_INVALIDO'
          ? 'Este link expirou ou já foi usado.'
          : 'Não foi possível confirmar agora.')
        setFase('falhou')
      }
    })()
  }, [token])

  return (
    <main className="cf">
      <div className="cf__caixa cartao">
        <Marca tamanho={26} />

        {fase === 'confirmando' && (
          <>
            <h1>Confirmando…</h1>
            <p className="ajuda" role="status">Um instante.</p>
          </>
        )}

        {fase === 'ok' && (
          <>
            <h1>E-mail confirmado</h1>
            <p className="ajuda">
              Pronto. Esse endereço agora é o caminho de volta se você esquecer a
              senha — e é para onde vão os avisos da clínica.
            </p>
            <button className="botao" onClick={aoEntrar}>Entrar no sistema</button>
          </>
        )}

        {fase === 'falhou' && (
          <>
            <h1>Não deu para confirmar</h1>
            <p className="ajuda">{motivo}</p>
            <p className="ajuda">
              Se você já tinha confirmado antes, está tudo certo — é só entrar.
              Se não, entre e peça um link novo em Ajustes › Conta e segurança.
            </p>
            <button className="botao botao--fantasma" onClick={aoEntrar}>Ir para o login</button>
          </>
        )}
      </div>
    </main>
  )
}
